import Header from "@commons/header";
import Column from "@components/column";
import React, { useEffect, useState } from "react";

import { useLocation, useParams, useSearchParams } from "react-router-dom";
import BackButton from "@components/backButton";
import Tab from "@components/tabs";
import Overview from "./overview";
import OrderList from "./orders";
import Transactions from "./transactions";
import Notifications from "./notifications";
import Withdrawals from "./withdrawals";
import DailyDeliveries from "./daily-deliveries";
import { DeliveryMan } from "@apis/index";
import Row from "@components/row";

const IndividualDelivery = () => {
  const { state: locationState } = useLocation();
  const { id } = useParams();
  const [state, setState] = useState<any>(locationState);
  const [loading, setLoading] = useState(!locationState?.phoneNo);

  useEffect(() => {
    // If navigated from dashboard with minimal state, fetch full data
    if (!locationState?.phoneNo && id) {
      setLoading(true);
      DeliveryMan.find({ id })
        .then((res: any) => {
          if (res) {
            setState(res);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id, locationState]);

  if (loading) {
    return (
      <Column>
        <BackButton path={`/admin/users/delivery-man/delivery-man-lists`} />
        <Header title="Loading..." />
      </Column>
    );
  }

  const tabs: any = [
    { label: "Overview", component: Overview, props: { state } },
    { label: "Daily Deliveries", component: DailyDeliveries, props: { state } },
    { label: "Transactions", component: Transactions, props: { state } },
    { label: "Order List", component: OrderList, props: { state } },
    { label: "Notifications", component: Notifications, props: { state } },
    { label: "Withdraw", component: Withdrawals, props: { state } },
  ];
  return (
    <Column>
      <BackButton path={`/admin/users/delivery-man/delivery-man-lists`} />

      <Tab items={tabs} />
    </Column>
  );
};

export default IndividualDelivery;
